/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getWebAuthnCredentials} from '../api'

 export const useQueryGetWebAuthnCredentials = createReactQueryHook('getWebAuthnCredentials', getWebAuthnCredentials)
